<template>
    <div>
        <div class="container">
            <div class="card-expired" v-if="cardExpired">
                <p>This card is expired or invalid</p>
            </div>
            <div v-if="filteredCardsByMerchant.length == 0" :class=" tabCardClasses( filteredCardsByMerchant.length == 0 )">
                <p>Available Cards:</p>
                <div class="number-cards">
                    <div class="bonus-cards">
                    <p>Bonus Cards</p>
                    <p>0 Available</p>
                    </div>
                </div>
                <div :class=" tabClasses( filteredCardsByMerchant.length == 0 )">
                    <p>You have no bonus card for this merchant at this time. To learn more ...</p>
                </div>
            </div>

            <div v-else>

                <h3 style="margin-left: 10px">Bonus Cards</h3>
                <div v-for=" ( card, cardKey ) in filteredCardsByMerchant " :key=" cardKey ">
                    <div class="outer-card">

                        <div class="inner-card" @click=" selectCard( card ) ">

                            <div class="image-wrapper">

                                <img :src=" card.GiftcardImage.name != null ? imageUrl + card.GiftcardImage.path + card.GiftcardImage.name : '/img/gift.png' " alt=""/>
                            </div>
                            <div class="description-wrapper">

                                <p class="merchant-name">{{ card.Merchant.name }}</p>
                                <p class="balance">${{ card.PrepaidAccount.balance }}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="btn-dont">
                <button @click="clearCurrentCard()">Do not use any Card this time</button>
            </div>
        </div>
    </div>
</template>
<script>
 import { mapGetters } from 'vuex';
export default {
    name: 'order-promotion-card',
            computed: {
            ...mapGetters({
                imageUrl                : 'imageUrl',
                filteredCardsByMerchant : 'cards/filteredCardsByMerchant',
                cardExpired             : 'cards/cardExpired'
            })
        },
        methods : {
            clearCurrentCard(){
                this.$store.dispatch( 'cards/clearCurrentCard' );
            },
            selectCard( card ){
                this.$store.dispatch( 'cards/selectCard', card );
            },
            tabClasses( isTrue ){

                const base = [ 'message-cards' ];
                base.push( isTrue ? '' : 'no-cards' );
                return base.join( ' ' );
            },
            tabCardClasses(isTrue){

                const base = [ '' ];
                base.push( isTrue ? '' : 'no-cards' );
                return base.join( ' ' );
            },
            created(){

            }
        }
}
</script>
<style>
    .container {
        padding:20px 30px;

    }
    .container .number-cards {
        padding-top:30px;
        text-align:right;
    }
    .container .number-cards .bonus-cards {
        color:#7c93b5;
        font-weight: bold;
    }

    .container .message-cards {
        margin-top:50px;
        padding:30px 20px 30px 20px;
        font-size:24px;
        border-radius:5px;
        border:1px solid red;
    }
    .container .btn-dont {
        margin-top:50px;
    }
    .container .btn-dont button{
        background: #72a85e;
        padding:15px 20px;
        width: 100%;
        border:none;
        border-radius:5px;
        color:white;
        font-size:14px;
    }

    /** Bonus cards */
    .outer-wrapper {

        margin: 0 auto;
        padding-top: 0 !important;
        max-width: 450px;
    }
    .outer-card {

        display: flex;
        align-items: center;

        height: 140px;
        padding: 5px;
        margin-bottom: 10px;
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );
    }
    .inner-card {

        display: flex;
        align-items: center;
        justify-content: space-between;

        cursor: pointer;
        position: relative;
        height: 100%;
        width: 100%;
        padding: 0px 10px;
    }

    .image-wrapper {

        position: relative;
        max-width: 125px;
        max-height: 62.5px;
    }
    .image-wrapper > img {

        width: 100%;
        max-height: 75px;
    }

    .description-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: right;

        height: 100%;
    }

    .merchant-name {

        font-weight: bold;
        font-size: 14px;
    }

    .balance {
        font-weight: bold;
        padding: 10px 0px;
        font-size: 24px;
    }
    .card-expired {
        color:white;
        background:#F63F3F;
        padding:10px;
        border-radius:2px;
    }
    .container .no-cards {
        display: none;
    }
</style>
